import { cdnEndpoints } from "./cdn-endpoints.function";
import { firebaseConfigUat } from "./firebase/firebase.uat";

// Archivo usado al hacer deploy a staging (online)
const apiUAT = 'https://api-uat.sancristobalonline.com.ar/';

const apiBaseUrl = apiUAT;
const cdnBaseUrl = 'https://content-uat.gruposancristobal.com/';

export const environment = {
  version: require('../../package.json').version,
  dependencies: require('../../package.json').dependencies,
  type: {
    id: 'uat',
    name: 'UAT'
  },
  apiBaseUrl: apiBaseUrl,
  production: true, // This is set to true to get the same bundle as production
  legacyPortal: 'https://diw2k3mul01/PortalSCNet/Productores/homeproductores.aspx',
  legacyPortalBase: 'https://pas-uat.sancristobal.com.ar',
  OORRPortalBase: 'https://uat-siniestrosrsvs.sancristobalonline.com.ar',
  thirdPartyPortalBase: 'https://www.sancristobalonline.com.ar',
  apiAuthUrl: apiBaseUrl + 'authapi',
  apiClaim: apiBaseUrl + 'siniestros-claim',
  apiAdmin: apiBaseUrl + 'siniestros-claimadmin',
  apiCommercialAutoUrl: apiBaseUrl + 'portalpas-commercialauto',
  apiUtilityUrl: apiBaseUrl + 'utility',
  apiNotifications: apiBaseUrl + 'siniestros-notification',
  ca7claim: apiBaseUrl + 'siniestros-ca7claim/api',
  account: 'claimimages',
  container: 'claimimages',
  appInsightsKey: '6ea9e6cf-4d38-4d47-ace8-9e295de55838',
  hotJarSiteId: 950805,
  apiClaimV2: apiBaseUrl + 'claim/api',
  lender: apiBaseUrl + `lender/api`,
  google: {
    taskManager: {
      token: 'GTM-NXJSC9P'
    }
  },
  server: {
    web: {
      home: 'https://productores-uat.sancristobalonline.com.ar'
    }
  },
  cdn: cdnEndpoints(cdnBaseUrl),
  firebase: firebaseConfigUat,
};
